import { FileType } from '@/hooks/useFileLoading';

export type ReportFormat = 'PDF' | 'CSV' | 'HTML';

export enum OrderByColumnEnum {
  code = 'domain.enums.order_columns_stock.code',
  description = 'domain.enums.order_columns_stock.description',
}

// Stock
export interface ReportManufacturersFormValues {
  name?: string;
  initialWord?: string;
  finalWord?: string;
}

export interface ReportManufacturersParams {
  format: string;
  name?: string;
}

export interface ReportPartsParams {
  format: string;
  partDescription?: string;
  companiesIds?: number[];
  subGroupIds?: number[];
  manufacturerIds?: number[];
  showPartsWithZeroStock?: boolean;
  orderByColumn: OrderByColumnEnum;
  showRealCost?: boolean;
  localizationFrom?: string;
  localizationTo?: string;
  showDetailProducts?: boolean;
  showPartApplication?: boolean;
  showPartCfop?: boolean;
  manufacturingCodeFrom?: string;
  manufacturingCodeTo?: string;
}

export interface ReportGroupsFormValues {
  description?: string;
  subArea?: number;
  active: string;
}

export interface ReportGroupsParams {
  format: string;
  description?: string;
  area?: string;
}

export interface ReportPlanAccountParams {
  active?: boolean;
  description?: string;
  destination?: string;
  format: string;
  hierarchy?: string;
}

export enum OrderByColumnReport {
  code = 0,
  description = 1,
}

export interface ReportPartsFormValues {
  partDescription: string;
  companies: number[];
  manufacturer: number[];
  group: number[];
  showRealCost: boolean;
  concealEmptyParts: 0 | 1;
  orderByColumn: OrderByColumnReport;
}

export interface ReportConsumablesFormValues {
  companies: number[];
  manufacturer: number[];
  groups: string[];
  orderByColumn: OrderByColumnReport;
  descriptionFrom?: string;
  descriptionTo?: string;
  fromLocalization?: string;
  toLocalization?: string;
}

export interface ReportConsumablesParams {
  companies?: string;
  descriptionFrom?: string;
  descriptionTo?: string;
  format: string;
  fromLocalization?: string;
  toLocalization?: string;
  groups?: string[];
  manufacturer?: string;
  orderByColumn: OrderByColumnReport;
}

// StockMinimum

export enum StockMinimumTypes {
  part = 'PART',
  consumable = 'CONSUMABLE',
}

export enum StockPartsOrderBy {
  localization = 'Localization',
  description = 'Description',
  Code = 'Code',
}

export enum StockMinimumFilterBy {
  sku = 'SKU',
  manufacturingCode = 'MANUFACTURING_CODE',
  barCode = 'BAR_CODE',
  description = 'DESCRIPTION',
  manufacturing = 'MANUFACTURING',
  group = 'GROUP',
  subGroup = 'SUB_GROUP',
}

export interface StockPartsFormValues {
  companiesIds: number[];
  localizationFrom: string;
  localizationTo: string;
  partDescription: string;
  subGroupIds: number[];
  manufacturerIds: number[];
  showDetailProducts: boolean;
  showPartApplication: boolean;
  showRealCost: boolean;
  showPartsWithZeroStock: boolean;
  orderByColumn: OrderByColumnEnum;
  showPartCfop?: boolean;
  manufacturingCodeFrom?: string;
  manufacturingCodeTo?: string;
}
export interface StockMinimumFormValues {
  companiesIds: number[];
  minimumStock: boolean;
  below: boolean;
  isActiveItems: boolean;
  isInactiveItems: boolean;
  type: StockMinimumTypes[];
  filterBy: StockMinimumFilterBy;
  filterFrom: string;
  filterTo: string;
  manufacturerIds: number[];
  groupIds: number[];
  subGroupsIds: number[];
  isMinimumStockGreaterThanZero?: boolean;
  isMinimumStockEqualToZero?: boolean;
}

export interface ReportMinimumStockParams {
  below?: boolean;
  companiesIds?: string;
  filterBy: StockMinimumFilterBy;
  filterFrom?: string;
  filterIds?: string;
  filterTo?: string;
  format?: FileType;
  isConsumable?: boolean;
  isPart?: boolean;
  minimumStock?: boolean;
  manufacturerIds?: number[];
  groupIds?: number[];
  subGroupIds?: number[];
}

export enum ReportInventoryFilterByEnum {
  AllItems = 'ALL',
  OnlyDifferentFromBefore = 'ITEMS_DIFF',
  OnlySelected = 'SELECTED',
}

export enum ReportInventoryOrderByEnum {
  ManufacturerCode = 'MANUFACTURER_CODE',
  Groups = 'GROUPS',
  Localization = 'LOCALIZATION',
}
export interface ReportInventoryFormValues {
  companyName: string;
  inventoryId: number;
  filterBy: ReportInventoryFilterByEnum;
  orderBy: ReportInventoryOrderByEnum;
  codeStart?: string;
  codeEnd?: string;
  localizationStart?: string;
  localizationEnd?: string;
  groupIds?: string;
}

export interface ReportInventoryParams {
  inventoryId: number;
  filterBy: ReportInventoryFilterByEnum;
  orderBy: ReportInventoryOrderByEnum;
  codeFrom?: string;
  codeTo?: string;
  localizationFrom?: string;
  localizationTo?: string;
  groups?: string;
  format: ReportFormat;
}
